import { cn } from "@/lib/utils";

interface TourDisabledAreaProps {
  /** Caller passes the `z-*` (and any other extras). The parent must be
   *  `relative isolate` so the z-index is scoped to the widget. */
  className?: string;
}

/**
 * Invisible click-blocker the tour drops over a highlighted widget so
 * users can't click it mid-walkthrough. Caller decides when to render it
 * (typically `tour?.isActive && <TourDisabledArea className="z-30" />`).
 */
const TourDisabledArea = ({ className }: TourDisabledAreaProps) => (
  <div className={cn("absolute inset-0", className)} aria-hidden="true" />
);

export default TourDisabledArea;
